export const productSegments = [
    'Primer',
    'Interior',
    'Exterior',
    'Distemper',
    'Putty',
    'Texture'
]